module.exports = __webpack_public_path__ + "img/symbol_8.70ec3aa2.png";